import {
    initAccountNumberAlert,
    initRevealInputOnClick,
    initVanillaForm
} from "../helper/formHelper";
import {addRecaptchaToken} from "../helper/recaptchaHelper";

document.addEventListener('DOMContentLoaded', function () {
    initVanillaForm('loginForm', (form) => {
        addRecaptchaToken(form);
    });
    initRevealInputOnClick('log_password');
    initAccountNumberAlert('log_email');
});
